import React from 'react';
import ReactTooltip from 'react-tooltip';
import language from '@language';
import NumberFormat from 'react-number-format';
import cl from 'classnames';
import { getMaxAmountCardInvoiceByCountry } from '@helpers/config-by-country';
import './style.scss';

const CardFormInvoice = (props) => {

    const { fields, errors, currency } = props;

    const handleChange = ({ name, value }) => {
        const newFields = { ...fields, [name]: value };
        props.onChange(newFields);
    }

    const handleChangeInvoice = (invoice, name, value) => {
        const newInvoices = fields.invoices.map(i => ((i.id === invoice.id) ? { ...invoice, [name]: value } : i));
        props.onChange({ ...fields, invoices: newInvoices });
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        props.onSubmit(props.fields);
    }

    const handleAddInvoice = (fields) => {
        props.addInvoice(fields);
    }

    const handleRemoveInvoice = (fields, invoice) => {
        props.removeInvoice(fields, invoice);
    }

    const maxAmount = getMaxAmountCardInvoiceByCountry(props.country);

    return (
        <div className="card-container">
            
            {errors['general'] && (
                <div id="error-box" className="error-box">
                    <p>{errors['general']}</p>
                </div>
            )} 
            <form
                id="dd-form"
                onSubmit={e => handleSubmit(e)}>

                <div>
                    <div className="row-input required-message">
                        <i className="fa fa-info-circle fa-lg" aria-hidden="true"></i>
                        <span>{language.card.inputs_required}</span>
                    </div>

                    <div className="row-input">
                        <div className={`input ${errors['client_number'] ? 'invalid' : ''}`}>
                            <label>{language.card.booking_client}</label>
                            <NumberFormat
                                name="client_number"
                                thousandSeparator={false}
                                allowNegative={false}
                                decimalSeparator=" "
                                required={true}
                                placeholder={language.card.booking_client_placeholder}
                                value={fields.client_number}
                                maxLength={8}
                                onValueChange={(value) => handleChange({ name: 'client_number', value: value.formattedValue })} />

                            {errors['client_number'] && <div className="error-tooltip">{errors['client_number']}</div>}
                        </div>

                        <div className={`input ${errors['property_name'] ? 'invalid' : ''}`}>
                            <label>{language.card.hotel_name}</label>
                            <input
                                name="property_name"
                                type="text"
                                required={true}
                                maxLength={50}
                                value={fields.property_name}
                                onChange={e => handleChange(e.target)}
                            />
                            {errors['property_name'] && <div className="error-tooltip">{errors['property_name']}</div>}
                        </div>

                        <div className={`input ${errors['document'] ? 'invalid' : ''}`}>
                            <label>
                                {language.card.document} 

                                <div className="document-tooltip" data-tip data-for="document_tooltip">
                                    <i className="fa fa-info-circle fa-lg" aria-hidden="true"></i>

                                    <ReactTooltip id="document_tooltip" place="top" type="dark" effect="solid">
                                        <span>{language.card.document_placeholder}</span>
                                    </ReactTooltip>
                                </div>
                            </label>
                            
                            <input
                                name="document"
                                type="text"
                                required={true}
                                value={fields.document}
                                onChange={(e) => handleChange(e.target)} />

                            {errors['document'] && <div className="error-tooltip">{errors['document']}</div>}
                        </div>

                        <div className={`input ${errors['email'] ? 'invalid' : ''}`}>
                            <label>{language.card.email}</label>
                            <input
                                name="email"
                                required={true}
                                type="text"
                                value={fields.email}
                                onChange={e => handleChange(e.target)}
                            />
                            {errors['email'] && <div className="error-tooltip">{errors['email']}</div>}
                        </div>
                    </div>

                    <div className="row-input billing-disclaimer">
                        <h3>{language.card.billing_title}</h3>
                        <p>{language.card.billing_description} 
                            <NumberFormat displayType="text" thousandSeparator="." decimalSeparator="," value={maxAmount} />
                            {language.card.currency_local}
                        </p>
                    </div>

                    {fields.invoices.map((invoice, index, arr) => (
                        <div className="row-input" key={invoice.id}>
                            <div className={`input ${errors['invoice_number'] ? 'invalid' : ''}`}>
                                {index === 0 && <label>{language.card.invoice_id_label}</label>}
                                <NumberFormat
                                    name="invoice_number"
                                    thousandSeparator={false}
                                    allowNegative={false}
                                    decimalSeparator=" "
                                    data-lpignore="true"
                                    required={index == 0 || !!invoice.amount}
                                    placeholder={language.card.invoice_id_placeholder}
                                    value={invoice.invoice_number}
                                    onValueChange={({ value }) => handleChangeInvoice(invoice, 'invoice_number', value)} />

                                {errors.invoices && !!errors.invoices[index] && (
                                    <div className="error-tooltip">{errors.invoices[index].invoice_number}</div>
                                )}
                            </div>

                            <div className={`input ${errors['amount'] ? 'invalid' : ''}`}>
                                {index === 0 && <label>{language.card.invoice_amount_label}</label>}
                                <div className="group">
                                    {currency && <span className="symbol">{currency}</span>}
                                    <NumberFormat
                                        name="amount"
                                        thousandSeparator="."
                                        allowNegative={false}
                                        decimalSeparator=","
                                        required={index == 0 || !!invoice.invoice_number}
                                        value={invoice.amount}
                                        onValueChange={(value) => handleChangeInvoice(invoice, 'amount', value.floatValue) } />
                                </div>
                                {errors.invoices && !!errors.invoices[index] && (
                                    <div className="error-tooltip">{errors.invoices[index].amount}</div>
                                )}
                            </div>

                            {(arr.length - 1 === index && index < 7) ?
                                <div className={cl("add-invoice", { first: index === 0 })}>

                                    <button className="button-secondary" type="button" onClick={() => handleAddInvoice(fields)}>
                                        <i className="fa fa-plus-circle" aria-hidden="true"></i>
                                        {language.card.add_invoice}
                                    </button>
                                </div>
                                : <div className={cl("remove-invoice", { first: index === 0 })}
                                    data-tip data-for="remove_tooltip"
                                    onClick={() => handleRemoveInvoice(fields, invoice)}>
                                    <i className="fa fa-lg fa-trash" aria-hidden="true"></i>

                                    <ReactTooltip id="remove_tooltip" place="top" type="dark" effect="solid">
                                        <span>{language.card.remove_tooltip}</span>
                                    </ReactTooltip>
                                </div>
                            }
                        </div>
                    ))}

                    {fields.total > 0 &&
                        <div className="row-input">
                            <div className="input"></div>
                            <div className="input total-amount">
                                <p>{language.card.total_amount}:
                                <NumberFormat
                                        displayType="text"
                                        thousandSeparator="."
                                        decimalSeparator=","
                                        prefix=" $"
                                        value={fields.total} />
                                </p>

                                {errors.amountMax && (
                                    <div className="error-amount">{language.card.amount.max}</div>
                                )}
                                {errors.amountMin && (
                                    <div className="error-amount">{language.card.amount.min}</div>
                                )}
                            </div>
                        </div>
                    }
                </div>

                <div className="submit-container">
                    <div className="submit">
                        <button type="submit">{language.continue}</button>
                    </div>
                </div>
            </form>
        </div >
    );
}

export default CardFormInvoice;